import React from 'react'
import {
  PixelButton,
  PixelFactoryContext,
  PixelFlexBox,
  PixelInput,
  PixelText,
} from 'pixel-base'
import { AjaxResponse } from 'rxjs/ajax'

import { registerCustomerStore } from 'utils/api-routes.util'
import {
  ManualFormHelp,
  ManualFormHelpCloseButton,
} from 'app/common/styles/section'

import HelpWooc from './HelpWoo'
import { IPixelFactory } from '../../../../../decl'

const WooCommerceManual = () => {
  const { showSuccess, showFailure, showPageLoader, hidePageLoader } =
    React.useContext<IPixelFactory>(PixelFactoryContext)
  const [showHelp, setShowHelp] = React.useState(false)

  const [data, setData] = React.useState({
    store_id: null,
    store_type: 'woocom',
    store_name: '',
    api_key: '',
    api_secret: '',
    host_url: '',
  })
  const [error, setError] = React.useState({
    error: '',
    field: '',
  })

  const handleSubmit = (e) => {
    e.preventDefault()
    handleAddStore(data)
  }

  const handleAddStore = (data) => {
    showPageLoader()
    registerCustomerStore(data).subscribe((res: AjaxResponse<any>) => {
      hidePageLoader()
      if (res.response.data) {
        showSuccess('Successfully Added')
      } else {
        if (res.response.error && res.response.field) {
          setError({
            error: res.response.error,
            field: res.response.field,
          })
        } else {
          showFailure(res.response.error)
        }
        hidePageLoader()
      }
    })
  }

  return (
    <>
      <PixelFlexBox position="relative" flexDirection="column">
        <PixelText variant="light" textSize="20px">
          Enter Woocommerce API Details
        </PixelText>
        <form onSubmit={handleSubmit}>
          <PixelFlexBox
            justifyContent="flex-start"
            alignItems="flex-end"
            flexDirection="column"
            gap="10px"
          >
            <PixelInput
              error={
                error.field === 'store_name' && error.error !== ''
                  ? error.error
                  : null
              }
              required
              placeholder="e.g. My Woocommerce Store"
              value={data.store_name}
              onChange={(e) =>
                setData({
                  ...data,
                  store_name: e.currentTarget.value,
                })
              }
            />
            <PixelInput
              error={
                error.field === 'host_url' && error.error !== ''
                  ? error.error
                  : null
              }
              required
              placeholder="e.g. http://yourstore.com"
              value={data.host_url}
              onChange={(e) =>
                setData({
                  ...data,
                  host_url: e.currentTarget.value,
                })
              }
            />
            <PixelInput
              error={
                error.field === 'api_key' && error.error !== ''
                  ? error.error
                  : null
              }
              required
              placeholder="e.g. ck_daa8daa7e9f585e679d9f25e50f988e61d2xxxx"
              value={data.api_key}
              onChange={(e) =>
                setData({
                  ...data,
                  api_key: e.currentTarget.value,
                })
              }
            />
            <PixelInput
              error={
                error.field === 'api_secret' && error.error !== ''
                  ? error.error
                  : null
              }
              required
              value={data.api_secret}
              onChange={(e) =>
                setData({
                  ...data,
                  api_secret: e.currentTarget.value,
                })
              }
              placeholder="e.g. cs_1455520d84f605cb7df7940b30625ae25388xxxx"
            />
            <PixelFlexBox
              justifyContent="flex-end"
              alignItems="flex-end"
              gap="10px"
              width="100%"
            >
              <PixelButton
                onClick={() => setShowHelp(true)}
                variant="secondary"
              >
                Help
              </PixelButton>
              <PixelButton type="submit">Add Store</PixelButton>
            </PixelFlexBox>
          </PixelFlexBox>
        </form>
        <ManualFormHelp className={showHelp ? 'show' : ''}>
          <ManualFormHelpCloseButton onClick={() => setShowHelp(false)}>
            &times;
          </ManualFormHelpCloseButton>
          <HelpWooc />
        </ManualFormHelp>
      </PixelFlexBox>
    </>
  )
}

export default WooCommerceManual
